import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import App from './app.vue'
import 'assets/css/base.css'
import 'assets/css/site.css'
import 'es6-promise/auto'

Vue.use(ElementUI)
new Vue({
    el: '#app',
    render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/pages/staticHome/app.js